module.exports = __webpack_public_path__ + "static/media/teamviewer.3c3571ce.jpg";